angular.module('lf.desktop')

.directive('popup', function ($parse, $compile, $rootScope, popupsService) {
  return {
    restrict: 'EA',
    scope: true,
    transclude: true,
    controller: function ($scope) {
      $scope.popup = {
        hide: function () {
          $scope.$broadcast('popup:hide', {name: this.name});
        }
      }
    },
    link: function (scope, el, attrs, ctrl, transclude) {
      var popup = {};
      
      popup.name = attrs.popup;
      
      if (!popup.name) {
        throw new Error('Popup component should have `name` (e.g. `popup="hello"`)');
      }
      
      scope.popup.name = popup.name;
      
      var options = $parse(attrs.popupOptions)(scope);
      
      var defaults = {
        fixed: true,
        centered: true,
        closeButton: true,
        overlay: true,
        hideOnOverlayClick: true,
        autoPosition: true,
        destroyOnHide: false,
        className: '',
        
        width: 'auto',
        height: 'auto',
        top: '50%',
        left: '50%'
      }
      
      var opts = $.extend({}, defaults, options);
      
      var tmpl = '<div class="ui-popup__container">' + 
                   '<div class="ui-popup__overlay" ng-click="popup.hide()"></div>' + 
                   '<div class="ui-popup__modal">' +
                     '<a class="ui-popup__close-button" ng-click="popup.hide()">' + 
                       '<i class="fa fa-times-circle"></i>' + 
                     '</a>' + 
                     '<div class="ui-popup__modal-content"></div>' + 
                   '</div>' + 
                 '</div>';
      
      popup.$container = $(tmpl);
      popup.$modal = popup.$container.find('.ui-popup__modal');
      popup.$content = popup.$modal.find('.ui-popup__modal-content');
      
      popup.$container.attr('data-popup-name', popup.name);

      if (opts.className) {
        popup.$modal.addClass(opts.className);
      }
      
      if (!opts.overlay) {
        popup.$container.find('.ui-popup__overlay').remove();
      }
      
      if (opts.overlay && !opts.hideOnOverlayClick) {
        popup.$container.find('.ui-popup__overlay').removeAttr('ng-click');
      }
      
      if (!opts.closeButton) {
        popup.$modal.find('.ui-popup__close-button').remove();
      } else {
        popup.$modal.on('click', '.ui-popup__close-button', function (e) {
          e.preventDefault();
        });
      }

      
      $compile(popup.$container)(scope);
      
      transclude(scope, function (clone) {
        popup.$content.append(clone);
        el.remove();
      });
      
      $('body').append(popup.$container);

      popupsService.register(popup.name);
      
      scope.$on('popup:show', function (e, args) {
        if (args.name !== popup.name) return;

        popup.$modal.css({'visibility': 'hidden'});
        popup.$container.show();
        setPosition();
        popup.$modal.css({'visibility': ''});
        scope.$broadcast('popup:shown');
      });
      
      scope.$on('popup:hide', function (e, args) {
        if (args.name !== popup.name) return;
        popup.$container.hide();
        scope.$broadcast('popup:hidden');
        if (opts.destroyOnHide) {
          scope.$destroy();
        }
      });
      
      scope.$on('popup:update', function (e, args) {
        if (args.name !== popup.name) return;
        
        if (args.content) {
          var content = $compile(args.content)(scope);
          popup.$content
          .empty()
          .append(content);
        }
        
        if (args.className) {
          popup.$modal.addClass(args.className);
        }

        if (args.position && opts.autoPosition) {
          setPosition();
        }
      });
      
      scope.$on('popup:destroy', function (e, args) {
        if (args.name !== popup.name) return;
        popup.$container.hide();
        scope.$destroy();
      });
      
      scope.$on('$destroy', function () {
        popupsService.unregister(popup.name);
        popup.$container.remove();
        popup = null;
      });

      function setPosition () {
        var modalWidth = opts.width === 'auto' ? popup.$modal.outerWidth() : opts.width;
        var modalHeight = opts.height === 'auto' ? popup.$modal.outerHeight() : opts.height;
        var windowHeight = $(window).height();
        var heightOverflow = false;
        var windowScrollY = window.scrollY ||
                            window.pageYOffset ||
                            document.documentElement && document.documentElement.scrollTop ||
                            document.body && (document.body.scrollTop || document.body.parentNode.scrollTop) ||
                            0;
        
        opts.marginLeft = opts.left === '50%' ? -(modalWidth / 2 | 0) : 0;
        
        if (modalHeight > windowHeight) {
          heightOverflow = true;
          opts.fixed = false;
          opts.top = windowScrollY + 50;
        } else {
          heightOverflow = false;
          opts.fixed = true;
          opts.top = '50%';
        }
        
        opts.position = opts.fixed ? 'fixed' : 'absolute';
        
        if (opts.centered && !heightOverflow) {
          opts.top = opts.fixed ? '50%' : windowScrollY + (windowHeight / 2 | 0);
          opts.marginTop = -(modalHeight / 2 | 0);
        }
        
        popup.$modal.css({
          position: opts.position,
          width: opts.width === 'auto' ? '' : opts.width,
          height: opts.height === 'auto' ? '' : opts.height,
          top: opts.top,
          left: opts.left,
          marginTop: opts.marginTop,
          marginLeft: opts.marginLeft
        });
      }
      
    }
  }
});
